import React from 'react';

export const openDesiredDatesPicker = (
  event?: React.MouseEvent<HTMLElement>,
) => {
  if (event) {
    event.preventDefault();
  }

  let datePickerTrigger: HTMLInputElement | null;

  datePickerTrigger = document.querySelector(
    '[data-test-locator="DateRangePicker / From / Input"]',
  );

  if (!datePickerTrigger) {
    datePickerTrigger = document.querySelector(
      '[data-test-locator="ListingRentalConditionsSection/DesiredDatesPickerTrigger"]',
    );
  }

  if (datePickerTrigger) {
    setTimeout(() => datePickerTrigger?.click(), 500);
  }
};
